import { useStudioStore } from '../../stores/studioStore';
import { getEngine } from '../../audio/engineBridge';
import type { MidiEditorTab } from '@melodinai/types';

const TABS: { id: MidiEditorTab; label: string }[] = [
  { id: 'notes', label: 'Notes' },
  { id: 'velocity', label: 'Velocity' },
  { id: 'expression', label: 'Expression' },
  { id: 'chance', label: 'Chance' },
  { id: 'scale', label: 'Scale' },
  { id: 'chords', label: 'Chords' },
  { id: 'groove', label: 'Groove' },
  { id: 'automation', label: 'Automation' },
];

/**
 * React chrome for Ableton-style MIDI Clip View.
 * Piano roll canvas + MIDI DSP stay in the legacy engine.
 */
export function MidiEditor() {
  const clip = useStudioStore((s) => s.selectedMidiClip);
  if (!clip) return null;

  const engine = getEngine();

  return (
    <div className="flex min-h-[200px] flex-col border-t border-daw-border bg-daw-surface">
      <div className="flex flex-wrap gap-1 border-b border-daw-border px-2 py-1">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className="rounded px-2 py-0.5 text-[10px] text-daw-muted hover:text-daw-text"
            onClick={() => engine.openMidiEditor?.()}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2 px-2 py-1 text-[10px] text-daw-muted">
        <span>{clip.notes.length} notes</span>
        <span>T{clip.transpose >= 0 ? '+' : ''}{clip.transpose}</span>
        <span>{clip.scaleEnabled ? clip.scaleMode : 'chromatic'}</span>
        <span>Groove {clip.grooveAmount || 0}%</span>
        <span>{clip.loopEnabled ? 'LOOP' : 'ONE-SHOT'}</span>
        <button
          type="button"
          className="rounded border border-daw-border px-2 py-0.5"
          onClick={() => engine.transformMidi?.('legato')}
        >
          Legato
        </button>
        <span className="ml-auto truncate text-daw-text">{clip.id}</span>
      </div>
      <div id="sdproLegacyMidiHost" className="min-h-[160px] flex-1" data-host="midi-clip" />
    </div>
  );
}
